<template>
  <div>
  <audio-player
    v-if="audioSource"
    :sources="[ audioSource ]"
    :preload="false"
    :playingEpisode="playingEpisode"
    :html5="true"
  ></audio-player>
  </div>
</template>

<script>
import AudioPlayer from './AudioPlayer'
export default {
  name: 'player-container',
  props: ['playingEpisode', 'audioSource'],
  components: {
    AudioPlayer
  }
}
</script>



// WEBPACK FOOTER //
// PlayerContainer.vue?75229d6b